import React from 'react';
import Full from './full';
import BackToStartButton from '../back-to-start-button';

export default function Totalizer({
  onRef,
  freeShippingEnabled,
  freeShippingAssetUrl,
  freeShippingThreshold,
  homeDeliveryItemsPrice,
  deliveryOptions,
  checkoutBlocker,
  price,
  quantity,
  shippingCost,
  selectedDeliveryOption,
  crossSellItemCheckOutClick,
}) {
  return (
    <div className="total-and-action card shadow-sm" data-test-id="totalizer">
      <div className="card-body" data-test-id="totalizer-full">
        <Full
          ref={onRef}
          price={price}
          quantity={quantity}
          shippingCost={shippingCost}
          checkoutBlocker={checkoutBlocker}
          deliveryOptions={deliveryOptions}
          freeShippingEnabled={freeShippingEnabled}
          freeShippingAssetUrl={freeShippingAssetUrl}
          freeShippingThreshold={freeShippingThreshold}
          homeDeliveryItemsPrice={homeDeliveryItemsPrice}
          selectedDeliveryOption={selectedDeliveryOption}
          crossSellItemCheckOutClick={crossSellItemCheckOutClick}
        />
        <BackToStartButton />
      </div>
    </div>
  );
}
